import { createContext } from 'react';

export const FormContext = createContext('');

export const SubGridContext = createContext(false);

export const SSGridContext = createContext({});

export const SSModalContext = createContext({});
